const ITEMS = [
  "汇聚项目资源",
  "连接可靠项目",
  "零风险赚钱项目",
  "四重专业审核",
  "合赢项目交流社区",
  "日赚500+稳定项目",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#0A0A0E] py-6" data-testid="editorial-marquee">
      <div className="marquee-track items-center gap-12 pr-12">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-12 shrink-0">
            {row.map((t, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-12 shrink-0">
                <span
                  className={`font-serif-sc text-3xl lg:text-5xl font-bold whitespace-nowrap ${
                    i % 2 === 0 ? "text-stroke-gold" : "text-gold-grad"
                  }`}
                >
                  {t}
                </span>
                <span className="w-2 h-2 rotate-45 bg-[#D4AF37]/50 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
